<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  async created() {
    const vm = this
     this.resetKey({
      credential: {
        resetKey: vm.$route.params.resetKey
      },
      vm: this
    })
  },
  computed: {
    ...mapState(['status']),
  },
  methods: {
    ...mapActions(['resetKey']),
  },
  watch: {
    'status.processing'(val) {
      if(val){
        this.$vs.loading();
      }else{
        this.$vs.loading.close();
      }
    }
  }
};
</script>

<style scoped>
  span.bold{
    color: #000000;
    font-size: 15px;
    font-weight: 600;
  }
</style>
